export default "__VITE_ASSET__DTQZECZ7__"